export function DownloadApplicantDataFromStorageExport()
{
    // Pobieranie danych zg�aszaj�cego z local.storage
    var VarApplicantName = localStorage.getItem("ApplicantName");
    var VarApplicantSurname = localStorage.getItem("ApplicantSurname");
    var VarApplicantPhone = localStorage.getItem("ApplicantPhone");
    // Maila nie sprawdzamy, mail nie jest obowi�zkowy
    if (!VarApplicantName || !VarApplicantSurname || !VarApplicantPhone)
    {
        alert('Brak mozliwosci automatycznego pobrania danych wlasciciela - uzupelnij dane recznie');
        console.log("Nie wykryto danych w�a�ciela pojazdu w obiektach local.storage, sprawd� ustawienia swojej przegl�drki pod k�tem obs�ugi plik�w cookies");
    }
    else
    {
        //Zmiana p�l na read-only
        document.querySelector('input[name="ownerPerson[name]"]').classList.add("Mui-disabled");
        document.querySelector('input[name="ownerPerson[surname]"]').classList.add("Mui-disabled");
        document.querySelector('input[name="ownerPerson[email]"]').classList.add("Mui-disabled");
        document.querySelector('input[name="ownerPerson[phone]"]').classList.add("Mui-disabled");
        document.querySelector('input[name="ownerPerson[name]"]').parentElement.classList.add("Mui-disabled");
        document.querySelector('input[name="ownerPerson[surname]"]').parentElement.classList.add("Mui-disabled");
        document.querySelector('input[name="ownerPerson[email]"]').parentElement.classList.add("Mui-disabled");
        document.querySelector('input[name="ownerPerson[phone]"]').parentElement.classList.add("Mui-disabled");

        //Ten kod zosta� zast�piony kodem TypeScript w funckji setApplicantIsOwner w lokalizacji FNOL\src\features\OC\Vehicle\VehicleOwner\vehicleOwner.slice.ts
        /*
        
        //Czyszczenie atrybut�w z kodu HTML
        document.querySelector('input[name="ownerPerson[name]"]').removeAttribute('disabled');
        document.querySelector('input[name="ownerPerson[surname]"]').removeAttribute('disabled');
        document.querySelector('input[name="ownerPerson[email]"]').removeAttribute('disabled');
        document.querySelector('input[name="ownerPerson[phone]"]').removeAttribute('disabled');
        document.querySelector('input[name="ownerPerson[name]"]').removeAttribute('aria-invalid');
        document.querySelector('input[name="ownerPerson[surname]"]').removeAttribute('aria-invalid');
        document.querySelector('input[name="ownerPerson[email]"]').removeAttribute('aria-invalid');
        document.querySelector('input[name="ownerPerson[phone]"]').removeAttribute('aria-invalid');
        document.querySelector('input[name="ownerPerson[name]"]').removeAttribute('autocomplete');
        document.querySelector('input[name="ownerPerson[surname]"]').removeAttribute('autocomplete');
        document.querySelector('input[name="ownerPerson[email]"]').removeAttribute('autocomplete');
        document.querySelector('input[name="ownerPerson[phone]"]').removeAttribute('autocomplete');

        // Pobieranie p�l formularza do zmiennych
        var ApplicantIsOwnerName = document.querySelector('input[name="ownerPerson[name]"]').value;
        var ApplicantIsOwnerSurname = document.querySelector('input[name="ownerPerson[surname]"]').value;
        var ApplicantIsOwnerEmail = document.querySelector('input[name="ownerPerson[email]"]').value;
        var ApplicantIsOwnerPhone = document.querySelector('input[name="ownerPerson[phone]"]').value;
       
        //Czyszczenie danych w�a�ciciela
        document.querySelector('input[name="ownerPerson[name]"]').removeAttribute('value');
        document.querySelector('input[name="ownerPerson[surname]"]').removeAttribute('value');
        document.querySelector('input[name="ownerPerson[email]"]').removeAttribute('value');
        document.querySelector('input[name="ownerPerson[phone]"]').removeAttribute('value');

        //Zapisywanie danych do value ( tekst wy�wietlany u�ytkownikowi )
        ApplicantIsOwnerName = VarApplicantName;
        ApplicantIsOwnerSurname = VarApplicantSurname;
        ApplicantIsOwnerEmail = VarApplicantEmail;
        ApplicantIsOwnerPhone = VarApplicantPhone;
        document.querySelector('input[name="ownerPerson[name]"]').value = VarApplicantName;
        document.querySelector('input[name="ownerPerson[surname]"]').value = VarApplicantSurname;
        document.querySelector('input[name="ownerPerson[email]"]').value = VarApplicantEmail;
        document.querySelector('input[name="ownerPerson[phone]"]').value = VarApplicantPhone;

        //Zapisywanie danych do value ( atrybut value w kodzie HTML strony )
        document.querySelector('input[name="ownerPerson[name]"]').setAttribute('value', VarApplicantName);
        document.querySelector('input[name="ownerPerson[surname]"]').setAttribute('value', VarApplicantSurname);
        document.querySelector('input[name="ownerPerson[email]"]').setAttribute('value', VarApplicantEmail);
        document.querySelector('input[name="ownerPerson[phone]"]').setAttribute('value', VarApplicantPhone);
        document.querySelector('input[name="ownerPerson[phone]"]').setAttribute('aria-invalid', false);

        //Dodanie atrybut�w disabled w prawdzie wy��cza klikalno�� p�l, ale uniemo�liwia prawid�owe zapisanie do nich danych przez co w reque�cie pola s� puste, nie w��cza� tego kodu
        document.querySelector('input[name="ownerPerson[name]"]').setAttribute('disabled', true);
        document.querySelector('input[name="ownerPerson[surname]"]').setAttribute('disabled', true);
        document.querySelector('input[name="ownerPerson[email]"]').setAttribute('disabled', true);
        document.querySelector('input[name="ownerPerson[phone]"]').setAttribute('disabled', true);
        */
    }
}